import {
  GET_BOOKING_DETAILS,
  GET_BOOKING_LIST,
  ADD_BOOKING,
  REMOVE_ADD_BOOKING
} from "../types";

const initialState = {
  response: null,
  loading: true,
  create: false,
  detail: false,
};

const initialStates = {
  response: null,
  loading: true,
  create: false,
};

export function bookingReducer(state = initialState, action) {
  switch (action.type) {
    case GET_BOOKING_LIST:
      return {
        ...state,
        create: false,
        detail: false,
        response: action.payload,
      };
    case GET_BOOKING_DETAILS:
      return {
        ...state,
        create: false,
        detail: true,
        response: action.payload,
      }
    default:
      return state;
  }
}

export function addBookingReducer(state = initialStates, action) {
  switch (action.type) {
      case ADD_BOOKING:
      return {
        ...state,
        create: true,
        response: action.payload,
      };
      case REMOVE_ADD_BOOKING:
        return {
            ...state,
            create: false,
            response: null,
        };
    default:
      return state;
  }
}